import { h } from 'preact'
import Moment from 'moment'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Project = (props) => {

  let project = props.project
  let title  = project.title
  let excerpt  = project.excerpt
  let short_excerpt = excerpt.substring(0, 110) + '...'
  let link  = project.url
  let raw_date = project.date
  let date = Moment(raw_date).format('DD/MM/YYYY')
  let feat_image = project.feat_image
  let company = project.company

  if (props.language == 'en') {
    date = Moment(raw_date).format('MM/DD/YYYY')
  }

  return (
      <div className="c-recent-project u-flex">

      <div className="c-recent-project__image-container">
      <a href={link} target="_blank">
      <div dangerouslySetInnerHTML={{ __html: feat_image }} />
  </a>
  </div>

  <div className="c-recent-project__content-container">
      <a
  href={link}
  target="_blank"
  className="c-recent-project__link"
      >

      <h4 className="c-recent-project__title" dangerouslySetInnerHTML={{ __html: title }} />

  <p className="c-recent-project__excerpt" dangerouslySetInnerHTML={{ __html: short_excerpt }} />

  <div className="c-recent-project__footer u-flex u-flex-sb">
      <div class="c-recent-project__branches">
      <span class="c-recent-project__branch">{date}</span>
      <span class="c-recent-project__branch c-recent-project__branch--two">{company}</span>
      </div>

      <div className="c-recent-project__icon-container">
      <svg class="c-icon c-recent-project__icon">
      <use href="#arrow-thin-right" xlinkHref="#arrow-thin-right"></use>
      </svg>
      </div>
      </div>

      </a>
      </div>

      </div>
)
}

export default Project



// WEBPACK FOOTER //
// ./src/js/recent-news/components/Project.js